document.addEventListener('DOMContentLoaded', function () {

    // Change 'Notify Me' button
    $('.btn--add-to-cart[disabled]').remove();
    $('.open-back_in_stock span').html('Contact Us')
    $('.product-card__sold-out').remove()

    $('.product-price').each(function () {
        var price = $(this).text().trim();
        if (price === '$0.00') {
            $(this).remove();
        }

    });

    // Replace page links
    document.querySelectorAll('a[href*="/collections/custom"]').forEach(a => {
        a.href = a.href.replace('/collections/custom', '/pages/custom-job');
    });

    // Collections replace page links
    const div = document.getElementById('shopify-block-AbFZ1VnZ5bFF2a25yc__collection_image_Pz4ydH');

    // Find the anchor tag inside the div
    const necklace = div.querySelectorAll('a[href="/collections/necklace"]');
    const earrings = div.querySelectorAll('a[href="/collections/earrings"]');
    const diamond = div.querySelectorAll('a[href="/collections/aggie-diamond"]');

    // If the necklace exists, change its href
    if (necklace) {
        necklace.forEach(nklc => {
            nklc.href = '/collections/shield™-collection';
        });
    }
    if (earrings) {
        earrings.forEach(earn => {
            earn.href = '/collections/shield™-collection';
        });
    }
    if (diamond) {
        diamond.forEach(dnmnd => {
            dnmnd.href = '/collections/aggie-shield™-diamonds';
        });
    }



    // Show modal on homepage
    $('.template-index #newsletterModal').modal('show');

    // Toggle active class
    const login_btn = document.getElementById("custom-login-account");
    const login_sidebar = document.querySelector(".login-popup");
    login_btn.addEventListener("click", function() {
        login_sidebar.classList.toggle("active");
    });

    // Global submit handler (works with modals + re-renders)
    document.addEventListener('submit', function (e) {
        const form = e.target;

        // Only target your newsletter form
        if (form && form.id === 'contact_form') {
            // e.preventDefault();
            // e.stopImmediatePropagation();

            // const discountCode = document.getElementById('discountCode');

            // // Prevent double submit
            // if (form.classList.contains('is-submitting')) return;
            // form.classList.add('is-submitting');

            // const formData = new FormData(form);

            // fetch('/contact', {
            //     method: 'POST',
            //     body: formData,
            //     headers: {
            //         'Accept': 'application/json'
            //     }
            // })
            // .then(response => {
            //     if (response.ok) {

            //         // Show discount
            //         if (discountCode) {
            //             discountCode.style.display = 'block';
            //             discountCode.scrollIntoView({
            //                 behavior: 'smooth',
            //                 block: 'center'
            //             });
            //         }

            //         // Reset form
            //         form.reset();

            //         // Optional: close modal after success
            //         setTimeout(() => {
            //             $('#newsletterModal').modal('hide');
            //         }, 1500);

            //     } else {
            //         throw new Error('Submission failed');
            //     }
            // })
            // .catch(() => {
            //     console.log('Something went wrong');
            // })
            // .finally(() => {
            //     form.classList.remove('is-submitting');
            // });

            // return false; // extra safety (blocks Shopify default)
        }
    }, true);

});